import React from "react";
import { Link } from "react-router-dom";

const BANNER_IMG =
  "./img/breadcrumb-bg.jpg";
const ABOUT_IMG =
  "./img/about.jpg";

const offerItems = [
  { icon: "./img/tracking.svg", label: "Real Time Tracking" },
  { icon: "./img/warehouse.svg", label: "Warehousing" },
  { icon: "./img/custom-clearance.svg", label: "Customs Clearance" },
  { icon: "./img/reliability.svg", label: "Reliability" },
  { icon: "./img/support.svg", label: "Customer Support" },
  { icon: "./img/global-network.svg", label: "Global Reach" },
  { icon: "./img/expertise.svg", label: "Expertise" },
  { icon: "./img/technology.svg", label: "Technology" },
];

const partners = [
  { name: "DHL", logo: "./img/partner/d2.png" },
  { name: "Fedex", logo: "./img/partner/d3.png" },
  { name: "Aramex", logo: "./img/partner/d4.png" },
  { name: "UPS", logo: "./img/partner/d5.png" },
  { name: "DPD", logo: "./img/partner/d6.png" },
  { name: "Bluedart", logo: "./img/partner/d8.png" },
];

export default function About() {
  return (
    <>
      <section
        className="rx-page-banner"
        style={{ backgroundImage: `url(${BANNER_IMG})` }}
      >
        <div className="rx-page-banner-overlay" />
        <div className="rx-page-banner-inner">
          <h1>About Us</h1>
          <div className="rx-breadcrumb">
            <Link to="/">Home</Link>
            <span>»</span>
            <span className="current">About Us</span>
          </div>
        </div>
      </section>

      <section className="rx-about-section">
        <div className="rx-about-grid">
          <div>
            <h2>
              About <span className="accent">Us</span>
            </h2>
            <p>
              At Reliable Express, we provide dependable logistics and transportation solutions designed to keep businesses moving. From freight transportation and e-commerce deliveries to warehousing and project logistics, we manage every shipment with care, precision, and accountability.
            </p>
            <p>
              With a strong focus on timely delivery, transparent communication, and customer satisfaction, our team works to simplify complex logistics and ensure your goods reach the right destination safely and efficiently.
            </p>
            <Link to="/services"><button className="rx-btn-dark">Our Services</button></Link>
          </div>
          <div className="rx-about-img-wrap">
            <img src={ABOUT_IMG} alt="Cargo plane on the tarmac" />
          </div>
        </div>
      </section>

      <section className="rx-offer-section">
        <div className="rx-offer-inner">
          <div className="rx-section-head">
            <h2>We Offer Our Customers</h2>
            <p>
              We're here to streamline your logistics process, ensuring
              efficiency, reliability, and cost-effectiveness every step of
              the way.
            </p>
          </div>
          <div className="rx-offer-grid">
            {offerItems.map((item, i) => (
              <div className="rx-offer-item" key={i}>
                <div className="rx-offer-icon">
                  <img src={item.icon} alt={item.label} width={40} height={40} />
                </div>
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="rx-partners-section">
        <h2 style={{ fontFamily: "var(--font-display)", fontSize: 30, color: "var(--navy)", margin: 0 }}>
          Our <span style={{ color: "var(--red)" }}>Partners</span>
        </h2>
        <div className="rx-partners-grid">
          {partners.map((p) => (
            <div className="rx-partner-plate" key={p.name}>
              <img src={p.logo} alt={p.name} />
            </div>
          ))}
        </div>
      </section>
    </>
  );
}